import React, { useState } from "react"
import Sentry from "../../Common/Sentry"
import { RequestHandler } from "../../Utils/request_handler"
import PublishSwitch from "./PublishSwitch"

export const PUBLISHED = "published"
export const UNPUBLISHED = "unpublished"

const PublishHandler: React.FC<{
  published: boolean
  placeId: number
}> = (props) => {
  const [published, setPublished] = useState(props.published)
  const onChange = async (e) => {
    const value = e.target.value
    const publishedAt = value == PUBLISHED ? new Date().toUTCString() : null
    const handler = new RequestHandler(
      `/admin/places/${props.placeId}/publish`,
      "PUT",
      { place: { published_at: publishedAt } }
    )
    const res = await handler.requestWithBody()
    if (res.status !== 200) {
      Sentry.captureMessage(res.body)
      return alert("通信に失敗しました。時間を置いてもう一度お試しください。")
    }
    setPublished(!published)
  }

  return <PublishSwitch published={published} onChange={onChange} />
}

export default PublishHandler
